import React from 'react'
import Svg from '../Icons/svgs/bg.svg'
import GreySvg from '../Icons/svgs/greybg.svg'
import PropTypes from 'prop-types'
import { Box, Center, Text, useColorMode } from '@chakra-ui/react'

const CurvyMore = ({ title, position }) => {
    const { colorMode } = useColorMode()
    const pos = position === 'left' ? '0' : '50%'
    const transform = position === 'left' ? `translateX(0)` : `translateX(-50%)`

    return (
        <Box position={'absolute'} bottom={'-1px'} zIndex={9} left={pos} transform={transform}>
            <Box w={['0', '0', '0', '580px', '480px']}>
                <Center display={['none', 'none', 'flex']}>
                    <Text
                        position={'absolute'}
                        fontWeight={'bold'}
                        fontSize={['0.8rem', '1rem']}
                        textTransform={'uppercase'}
                        color={colorMode === 'light' ? 'brand.blue' : 'brand.yellow'}
                    >
                        {title}
                    </Text>

                    {colorMode === 'light' && <img src={GreySvg} alt="background svg" />}
                    {colorMode === 'dark' && <img src={Svg} alt="background svg" />}
                </Center>
            </Box>
        </Box>
    )
}

CurvyMore.propTypes = {
    title: PropTypes.string,
    position: PropTypes.string,
}

CurvyMore.defaultProps = {
    title: '',
    position: 'center',
}

export default CurvyMore
